import { c as _c } from "react/compiler-runtime";
import { LabelWithHelp } from "@components/common/label-with-help";
import { AvatarGroup, Tooltip } from "@flat-ui";
import { Grid } from "@mui-wrapper";
import { TeamMemberAvatar } from "@pages/project-details/project-overview/team-member-avatar";
import { getUserTooltipDisplayName } from "@utils/user-utils";
/**
 * @returns the `+N` count, with a tooltip listing the members it stands for. Without a tooltip
 * when only some of the members were loaded, since the list would be incomplete.
 */
function RemainingMembers(t0) {
  const $ = _c(12);
  const {
    members,
    surplus
  } = t0;
  const count = `+${surplus}`;
  if (members.length < surplus) {
    let t1;
    if ($[0] !== count) {
      t1 = <var>{count}</var>;
      $[0] = count;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== members) {
    t1 = members.map(_temp);
    $[2] = members;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <div>{t1}</div>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 1,
      height: 1
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== count) {
    t4 = <var>{count}</var>;
    $[7] = count;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <Tooltip component="div" title={t2} disableInteractive={false} sx={t3}>{t4}</Tooltip>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}

/** Renders members avatar group */
function _temp(member) {
  return getUserTooltipDisplayName({
    member
  });
}
export function MemberAvatars(t0) {
  const $ = _c(18);
  const {
    members,
    maxMemberAvatars,
    label,
    membersCount,
    size
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignItems: "flex-end",
      justifyContent: "space-between"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== label) {
    t2 = label && <LabelWithHelp title={label} sx={{
      color: "text.secondary",
      fontWeight: "normal",
      fontSize: "11px"
    }} />;
    $[1] = label;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      justifyContent: "flex-end"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = maxMemberAvatars + 1;
  const t5 = membersCount ?? members.length;
  let t6;
  if ($[4] !== maxMemberAvatars || $[5] !== members) {
    t6 = surplus => <RemainingMembers members={members.slice(maxMemberAvatars)} surplus={surplus} />;
    $[4] = maxMemberAvatars;
    $[5] = members;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== members) {
    t7 = members.map(_temp2);
    $[7] = members;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== size || $[10] !== t4 || $[11] !== t5 || $[12] !== t6 || $[13] !== t7) {
    t8 = <AvatarGroup sx={t3} max={t4} total={t5} size={size} renderSurplus={t6}>{t7}</AvatarGroup>;
    $[9] = size;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t2 || $[16] !== t8) {
    t9 = <Grid container={true} sx={t1}><Grid>{t2}{t8}</Grid></Grid>;
    $[15] = t2;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}
function _temp2(member) {
  return <TeamMemberAvatar key={member.identity} member={member} />;
}